import React from 'react';
import { LockIcon, ShieldCheckIcon } from 'lucide-react';
import { checkoutUrl, mockupUrl } from '../data/content';
import { pricing } from '../data/bonuses';
import { Button } from './ui/Button';
import { OfferLink } from './ui/OfferLink';
export function FinalClose() {
  return <section className="bg-navy px-4 py-12 md:py-16" data-id="element-61" data-mp="i4zexbfd3bx7">
      <div className="mx-auto max-w-3xl text-center" data-id="element-62" data-mp="i6iuezt71ixx">
        <p className="font-display text-[11px] font-black uppercase tracking-[.25em] text-brand-light md:text-xs" data-id="element-63" data-mp="1ft9ezkvl7plo">
          One last question
        </p>
        <h2 className="mx-auto mt-3 max-w-2xl font-display text-lg font-black uppercase leading-snug text-white md:text-2xl" data-id="element-64" data-mp="1auew6ixme11k">
          How much easier would it be to have your rehabilitation exercise library already organized by body area,
          level and progression?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-white/75" data-id="element-65" data-mp="1yksf9jy88pk0">
          You can continue piecing together exercises from different resources. Or you can have one structured system
          for:
        </p>
        <p className="mt-3 font-display text-sm font-black uppercase tracking-wider text-brand-light md:text-base" data-id="element-66" data-mp="nroo00og7krw">
          Mobility. Strength. Stability. Progression.
        </p>

        <OfferLink href={checkoutUrl} className="mx-auto mt-8 max-w-[260px]" label={`Get instant access for $${pricing.price}`} data-id="element-67" data-mp="dz97l7ssv494">
          <img src={mockupUrl} alt="Complete Injury Rehabilitation Bundle mockup" className="w-full rounded-2xl bg-white object-contain p-3 shadow-2xl transition-transform duration-300 ease-out group-hover:scale-[1.015]" data-id="element-68" data-mp="4z2v9p8u8abj" />
        </OfferLink>

        <p className="mt-6 font-display text-base font-black uppercase text-white md:text-lg" data-id="element-69" data-mp="3w54am9zu5q2z">
          Complete Injury Rehabilitation Bundle
        </p>
        <p className="mt-1 font-display text-xs font-extrabold uppercase tracking-wide text-white/70" data-id="element-70" data-mp="1pfzfqwgsa65d">
          5 Complete Volumes + 5 Practical Bonuses
        </p>
        <p className="mt-5 font-display text-sm font-black uppercase tracking-wider text-brand-light" data-id="element-71" data-mp="1sx50t0hiv5rq">
          Get the complete system today
        </p>

        <div className="mt-4" data-id="element-72" data-mp="1nzlnc2snex0u">
          <Button href={checkoutUrl} size="lg" subtext="Instant Access • Digital Delivery" data-id="element-73" data-mp="1iy6147eqikgv">
            Get instant access — ${pricing.price}
          </Button>
        </div>
        <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-[11px] font-bold uppercase tracking-wide text-white/80" data-id="element-74" data-mp="1e1fjhfna7gtc">
          <li className="flex items-center gap-1.5" data-id="element-75" data-mp="26ngwf9dbfmnm">
            <ShieldCheckIcon className="h-4 w-4 text-brand-light" aria-hidden="true" data-id="element-76" data-mp="26q3dq0q0dgj1" /> 7-Day Guarantee
          </li>
          <li className="flex items-center gap-1.5" data-id="element-77" data-mp="21uxkegua0zkx">
            <LockIcon className="h-4 w-4 text-brand-light" aria-hidden="true" data-id="element-78" data-mp="1wxfj9cmi3onh" /> Secure Payment
          </li>
        </ul>
      </div>
    </section>;
}